import React from 'react';
import PropTypes from 'prop-types';

const Failed = ({ size = 'sm', ...props }) =>
  size === 'lg' ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#CB2C2C" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6628 17.3462C19.0152 16.8426 18.0787 16.8884 17.4836 17.4836C16.8388 18.1283 16.8388 19.1736 17.4836 19.8183L21.6652 24L17.4836 28.1817L17.3462 28.3372C16.8426 28.9848 16.8884 29.9213 17.4836 30.5165C18.1283 31.1612 19.1736 31.1612 19.8183 30.5165L24 26.3348L28.1817 30.5165L28.3372 30.6538C28.9848 31.1574 29.9213 31.1116 30.5165 30.5165C31.1612 29.8717 31.1612 28.8264 30.5165 28.1817L26.3348 24L30.5165 19.8183L30.6538 19.6628C31.1574 19.0152 31.1116 18.0787 30.5165 17.4836C29.8717 16.8388 28.8264 16.8388 28.1817 17.4836L24 21.6652L19.8183 17.4836L19.6628 17.3462Z"
        fill="white"
      />
    </svg>
  ) : (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="9" cy="9" r="9" fill="#CB2C2C" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.37267 4.96971C5.98037 4.66469 5.41314 4.69242 5.05266 5.0529C4.66213 5.44343 4.66213 6.07659 5.05266 6.46712L7.58555 9.00001L5.05266 11.5329L4.96947 11.6271C4.66445 12.0194 4.69217 12.5866 5.05266 12.9471C5.44318 13.3376 6.07635 13.3376 6.46687 12.9471L8.99977 10.4142L11.5327 12.9471L11.6269 13.0303C12.0192 13.3353 12.5864 13.3076 12.9469 12.9471C13.3374 12.5566 13.3374 11.9234 12.9469 11.5329L10.414 9.00001L12.9469 6.46712L13.0301 6.37291C13.3351 5.98062 13.3074 5.41339 12.9469 5.0529C12.5563 4.66238 11.9232 4.66238 11.5327 5.0529L8.99977 7.5858L6.46687 5.0529L6.37267 4.96971Z"
        fill="white"
      />
    </svg>
  );

Failed.propTypes = {
  size: PropTypes.string,
};

export default Failed;
